import RotatingTextAnimation from "@/components/ui/RotatingTextAnimation";
import { Skeleton } from "@/components/ui/skeleton";
import { cn } from "@/lib/utils";

interface ToolCallStatusShimmerProps {
  status: string;
  className?: string;
  infoText?: string;
}

const ToolCallStatusShimmer: React.FC<ToolCallStatusShimmerProps> = ({
  status,
  className,
  infoText,
}) => (
  <Skeleton
    className={cn(
      "flex min-h-[40px] flex-col items-center justify-center gap-2 px-4 py-2",
      className,
    )}
  >
    <RotatingTextAnimation
      key={status}
      phrases={[status ?? "Processing..."]}
      interval={1000}
      disableBlur
      className="text-xs font-medium text-gray-600"
    />
    {infoText && <span className="text-[11px] italic text-gray-400">{infoText}</span>}
  </Skeleton>
);

export default ToolCallStatusShimmer;
